import { inject } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';
import { UserStore } from '../user';
import { FETCH_TIMEOUT } from './models';

/**
 * Guard for the onboarding route. Allows access only when the user is authenticated
 * but has no profile (404 from /me). Redirects to / if user already exists.
 */
export const onboardingGuard = () => {
    const userStore = inject(UserStore);
    const router = inject(Router);

    return userStore.meStatus$.pipe(
        filter((status) => status === 'success' || status === 'error'),
        take(1),
        map((status) => {
            const user = userStore.me();
            const error = userStore.meQuery.error();
            let result: boolean | UrlTree;
            if (status === 'success' && user) {
                result = router.createUrlTree(['/']);
            } else if (status === 'error' && error?.status === 404) {
                result = true;
            } else {
                result = router.createUrlTree(['/login']);
            }
            return result;
        }),
        timeout(FETCH_TIMEOUT),
        catchError(() => of(router.createUrlTree(['/service-unavailable'])))
    );
};
